import { Component } from '@angular/core';
import { getVar } from 'src/app/shared/Utils/css';

@Component({
  selector: 'app-ip-default-avatar',
  templateUrl: './ip-default-avatar.component.html',
  styleUrls: ['./ip-default-avatar.component.scss']
})
export class IpDefaultAvatarComponent {
  circleColor = getVar('--global-secondary-color') + '50';
}
